import React from 'react'
import { BreadcrumbItem } from '@components/breadcrumb-item'

interface Breadcrumb {
  title: string
  slug: string
}

interface Props {
  breadcrumb: Breadcrumb[]
}

export const BreadcrumbPage = ({ breadcrumb }: Props) => {
  const getBreadcrumbUrlInvididual = (
    array: Breadcrumb[],
    currentIndex: number
  ) => {
    const slicedBreadcrumb = array.slice(0, currentIndex + 1)
    const currentUrlBreadcrumb = slicedBreadcrumb
      .map(item => item.slug)
      .join('/')
    return currentUrlBreadcrumb
  }

  return (
    <>
      <BreadcrumbItem path="/" title="Portal Solar" />
      <span className="text-orange px-1">/</span>
      {breadcrumb.map((item, index, array) => (
        <React.Fragment key={item.slug}>
          <BreadcrumbItem
            path={`/${getBreadcrumbUrlInvididual(array, index)}`}
            title={item.title}
          />
          {array[index] !== array[array.length - 1] && (
            <span className="text-orange px-1">/</span>
          )}
        </React.Fragment>
      ))}
    </>
  )
}
